import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.auth;

export const isLoadingLoginSelector = createSelector(getState, (state) => state.isLoadingLogin);
export const formErrorsSelector = createSelector(getState, (state) => state.formErrors);
export const loginErrorsSelector = createSelector(getState, (state) => state.loginErrors);
export const registerErrorsSelector = createSelector(getState, (state) => state.registerErrors);
export const registerEmailSelector = createSelector(getState, (state) => state.registerEmail);
export const twoFaDataSelector = createSelector(getState, (state) => state.twoFaData);
